export default __webpack_public_path__ + "img/bmGsWIgv.d823e4d5.svg";